export class StatusConstants {
  static readonly INFO: string = "info";
  static readonly WARNING: string = "warning";
  static readonly DANGER: string = "danger";
  static readonly SUCCESS: string = "success";
}
